import {createFormActionTypes} from "../../../../shared/ts/helpers/create_form_action_types";
import {createFormActions} from "../../../../shared/ts/helpers/create_form_actions";

export const OFFER_TAGS_LIST_FORM = "offer-tags/OFFER_TAGS_LIST_FORM";
export const offerTagsListFormTypes = createFormActionTypes(OFFER_TAGS_LIST_FORM);
export const offerTagsListFormActions = createFormActions(offerTagsListFormTypes);
